import React from 'react';
import styles from '../transactionsShuttle/TransactionsShuttle.module.css';
import SimpleLoader from '../loaders/SimpleLoader';
import BzmIcon from '../icons/BzmIcon';
import { BlazeTableOptions, SelectAllType } from '../blazeTable/BlazeTable.types';
import ShuttlePane from './ShuttlePane';
import { SortConfiguration } from '../../types/rest/paginationTypes';
import { PanePosition } from '../../store/transactionShuttle/TransactionShuttleTypes';

interface ShuttleButton {
  disabled: boolean;
  inProgress: boolean;
}

export interface ShuttleState {
  leftPane: PaneState;
  rightPane: PaneState;
  isMoveLeftInProgress: boolean;
  isMoveRightInProgress: boolean;
}

export interface PaneState {
  selected: any[];
  expanded: number | null;
  isLoading: boolean;
  searchTerm: string;
  activePage: number;
  totalResults: number;
  pageSize: number;
  data?: any[];
  sort?: SortConfiguration;
  selectAll?: SelectAllType | null;
}

export interface PaneConfig {
  title: string;
  tableOptions: BlazeTableOptions;
  state: PaneState;
}

interface Props {
  leftButton: ShuttleButton;
  rightButton: ShuttleButton;
  paneConfigs: {
    left: PaneConfig;
    right: PaneConfig;
  };
  /**
   * State change handler.
   * @param position - LEFT or RIGHT
   * @param update - The updated state of the pane.
   * @param reload - If true, the pane should be reloaded.
   */
  onStateChange: (position: PanePosition, update: PaneState, reload?: boolean) => void;
  /**
   * Move click handler
   * @param direction
   */
  onMove: (direction: PanePosition) => void;
}

const Shuttle = ({ leftButton, rightButton, paneConfigs, onStateChange, onMove }: Props) => {
  const getMoveRightButton = () => (
    <button
      className="btn btn-primary btn-square btn-lg mb-4"
      onClick={() => {
        onMove('RIGHT');
      }}
      disabled={rightButton.disabled}
    >
      {rightButton.inProgress ? (
        <SimpleLoader loadingText={''} style={{ position: 'relative', top: '-1px', left: '-1px' }} />
      ) : (
        <BzmIcon variant={'icon-bzm-chevron-right'} className={'icon-sm'} />
      )}
    </button>
  );

  const getMoveLeftButton = () => (
    <button
      className="btn btn-primary btn-square btn-lg"
      onClick={() => {
        onMove('LEFT');
      }}
      disabled={leftButton.disabled}
    >
      {leftButton.inProgress ? (
        <SimpleLoader loadingText={''} style={{ position: 'relative', top: '-1px', left: '-1px' }} />
      ) : (
        <BzmIcon variant={'icon-bzm-chevron-left'} className={'icon-sm'} />
      )}
    </button>
  );

  return (
    <div className={'d-flex flex-nowrap'}>
      <div className={'left-pane'}>
        <ShuttlePane
          paneConfig={paneConfigs.left}
          onStateChanged={(update, reload) => onStateChange('LEFT', update, reload)}
        />
      </div>

      <div className={`align-self-center ${styles.shuttleButtonsSection}`}>
        {getMoveRightButton()}
        {getMoveLeftButton()}
      </div>

      <div className={'right-pane'}>
        <ShuttlePane
          onStateChanged={(update, reload) => onStateChange('RIGHT', update, reload)}
          paneConfig={paneConfigs.right}
        />
      </div>
    </div>
  );
};

export default Shuttle;
